<template>
    <div v-if="data">
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back()"></vs-button>
                        <h4 style="margin-left: 10px">Wave Pick Planning</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-dropdown vs-trigger-click>
                            <vs-button class="btn mb-4 md:mb-0" icon="apps">Process</vs-button>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="printPicklist"> Print Picklist </vs-dropdown-item>
                                <vs-dropdown-item @click="confirmAll"> Confirm All Movement </vs-dropdown-item>
                                <vs-dropdown-item @click="checkingPacking"> Checking & Packing </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-row mt-5">
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input disabled class="w-full" v-model="data.id"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Reference
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input disabled class="w-full" v-model="data.reference"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Date*
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr disabled class="w-full" v-model="data.date"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Client
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input disabled class="w-full" v-model="data.client"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Warehouse
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input disabled class="w-full" v-model="data.warehouse"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Total Volume
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input disabled class="w-full" v-model="data.total_volume"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Total Weight
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input disabled class="w-full" v-model="data.total_weight"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Picking Line
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input disabled class="w-full" v-model="data.picking_line"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Total Qty
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input disabled class="w-full" v-model="data.total_quantity"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Total Order
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input disabled class="w-full" v-model="data.total_order"/>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                id: null,
                data: {},
                isLoading: false,
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData() {
                this.isLoading = true;
                this.$http.get(`wavepick/${this.id}`)
                .then(res => {
                    this.isLoading = false;
                    this.data = res.data;
                })
                .catch(error => this.handleError(error))
            },
            printPicklist() {
                this.isLoading = true
                this.$http.get('wavepick/' + this.id + '/printpickinglist', { responseType: 'blob' })
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => this.handleError(error, true))
            },
            confirmAll() {
                this.isLoading = true
                this.$http.get('wavepick/' + this.id + '/confirmall')
                .then(response => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: response.data.message || 'Success'
                    });
                })
                .catch(error => this.handleError(error))
            },
            back() {
                this.$router.push({name: 'wave-pick-planning'});
            },
            checkingPacking() {
                this.isLoading = true;
                this.$http.get('wavepick/' + this.id + '/getcheckingid')
                .then(res => {
                    this.isLoading = false;
                    this.$router.push({
                        name: 'checking-packing',
                        params: {
                            fromDeliveryOrder: true,
                            movement_id: res.data,
                            wavepick_id: this.id
                        }
                    })
                })
                .catch(error => this.handleError(error));
            }
        },
        mounted(){
            this.isLoading = true;
            this.id = this.$route.params.id;
            
            if(!this.id) {
                this.isLoading = false;
                return this.back();
            }
            
            this.fetchData();
        },
	}
</script>